import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDebounce } from '@/shared/hooks/useDebounce.ts';

export function useFormFieldSearch(name: string, debounceMs = 300) {
    const { watch } = useFormContext();
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    useDebounce(search, debounceMs, setDebouncedSearch);

    const fieldValue = watch(name);

    useEffect(() => {
        if (!fieldValue) setSearch('');
    }, [fieldValue]);

    return { search, setSearch, debouncedSearch };
}
